import { JSONSchema7 } from 'json-schema';
import { types as commonTypes } from '@sitebuilder/common';
import AnalyticsOnLoad from './AnalyticsOnLoad';

const schema: JSONSchema7 = {
    title: 'Analytics on Load',
    type: 'object',
    required: [],
    properties: {
        dynamicEvents: {
            type: 'array',
            title: 'Add Event with Custom Configuration for Page load',
            items: {
                type: 'object',
                properties: {
                    eventName: {
                        type: 'string',
                        title: 'Event Name',
                    },
                    analyticItems: {
                        type: 'array',
                        title: 'Page Analytics Items',
                        items: {
                            type: 'object',
                            properties: {
                                name: {
                                    type: 'string',
                                    title: 'Name',
                                },
                                value: {
                                    type: 'string',
                                    title: 'Value',
                                },
                            },
                        },
                    },
                },
            },
        },
    },
};

const groups = [
    {
        Values: ['dynamicEvents'],
    },
];

const AnalyticsOnLoadWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        dynamicEvents: {
            items: {
                eventName: { 'ui:widget': 'CustomTextInput' },
                analyticItems: {
                    items: {
                        name: { 'ui:widget': 'CustomTextInput' },
                        value: { 'ui:widget': 'ResourcePicker' },
                    },
                },
            },
        },
    },
    templateView: AnalyticsOnLoad,
    id: 'AnalyticsOnLoad',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default AnalyticsOnLoadWidget;
